import { OrderFormPayloadBaseSchema, OrderFormPayloadBaseType } from './OrderForm';

export type UpsellEventType = 'UpsellImpression' | 'UpsellClicked';

export type UpsellEventTypePayloadMap = {
  UpsellImpression: OrderFormPayloadBaseType;
  UpsellClicked: OrderFormPayloadBaseType;
};

export const UpsellEventSchemaMap: Record<UpsellEventType, typeof OrderFormPayloadBaseSchema> = {
  UpsellImpression: OrderFormPayloadBaseSchema,
  UpsellClicked: OrderFormPayloadBaseSchema,
};
